import { render, staticRenderFns } from "./Jyjingxuan.vue?vue&type=template&id=b3d658c6&scoped=true"
import script from "./Jyjingxuan.vue?vue&type=script&lang=js"
export * from "./Jyjingxuan.vue?vue&type=script&lang=js"
import style0 from "./Jyjingxuan.vue?vue&type=style&index=0&id=b3d658c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d658c6",
  null
  
)

export default component.exports